import bemCssModules from 'bem-css-modules';
import type { VFC } from 'react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import SearchResultPageModuleCss from './SearchResultPage.module.css';
import { SearchHeader } from '~/components/SearchHeader/SearchHeader';
import { SearchResults } from '~/components/SearchResults/SearchResults';
import { useSearchResultStore } from '~/stores';

const block = bemCssModules(SearchResultPageModuleCss);

export const SearchResultPage: VFC = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { setSearchQuery, loadSearchResults, searchQuestions } = useSearchResultStore();

  const searchPath = useLocation().search;
  const queryParts = searchPath.match(`query=([^\\/?&#]*)`);
  const query = queryParts ? queryParts[1] : null;

  useEffect(() => {
    const searchQuery = async () => {
      if (query && !searchQuestions.length) {
        const decodedQuery = window.decodeURI(query);
        setSearchQuery(decodedQuery);
        await loadSearchResults(decodedQuery);
      }

      setIsLoaded(true);
    };

    searchQuery();
  }, [loadSearchResults, query, searchQuestions.length, setSearchQuery]);

  if (!isLoaded) {
    return null;
  }

  return (
    <div className={block()}>
      <SearchHeader />
      <SearchResults />
    </div>
  );
};
